// ============================================================
// floatState — エージェントのフロート位置・最小化状態の保存
//
// 正: booking-platform/md/ai-control-center.md §16-4（S1 フロート化）
//
// パネルと最小化ボタン（●）の位置、最小化フラグを localStorage に保存する。
// 位置は画面サイズが変わっても必ず画面内に収まるよう、読み出し時に clamp する。
// ============================================================

export interface FloatPos { x: number; y: number; }

export interface FloatState {
  /** パネル左上の位置。null = 既定（右上） */
  panelPos: FloatPos | null;
  /** 最小化ボタン（●）の位置。null = 既定（右下） */
  bubblePos: FloatPos | null;
  /** true = ● に最小化されている */
  minimized: boolean;
}

const KEY = 'agent.float.v1';

export function loadFloatState(): FloatState {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { panelPos: null, bubblePos: null, minimized: false };
    const p = JSON.parse(raw);
    return {
      panelPos: isPos(p?.panelPos) ? p.panelPos : null,
      bubblePos: isPos(p?.bubblePos) ? p.bubblePos : null,
      minimized: p?.minimized === true,
    };
  } catch {
    return { panelPos: null, bubblePos: null, minimized: false };
  }
}

export function saveFloatState(state: FloatState): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(state));
  } catch {
    /* 保存できなくても動作は継続する（次回は既定位置に戻るだけ） */
  }
}

function isPos(v: any): v is FloatPos {
  return v && Number.isFinite(v.x) && Number.isFinite(v.y);
}

/** 位置を画面内に収める（画面サイズ変更・別解像度の端末でも見失わないように） */
export function clampPos(pos: FloatPos, w: number, h: number): FloatPos {
  return {
    x: Math.min(Math.max(0, pos.x), Math.max(0, window.innerWidth - w)),
    y: Math.min(Math.max(0, pos.y), Math.max(0, window.innerHeight - h)),
  };
}
